/**
 * @Author: Zewei
 * @Date:   2018-01-31T17:19:45+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-23T14:12:33+08:00
 */

import React from 'react';
import { Modal, Button, Form, Tree } from 'antd';

const FormItem = Form.Item;
const TreeNode = Tree.TreeNode;

class DepartmentMoveModal extends React.PureComponent {

    renderTreeNodes = (data) => {
      return data.map((item) => {
        if (item.children) {
          return (
            <TreeNode title={item.name} key={item.id} dataRef={item}>
              {this.renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.id} {...item}  title={item.name}  />;
      });
    }

    render() {
        const { visible, title, treeData, defaultExpandedKeys,
                handleCancel, handleUpdate, onSelectTreeNode } = this.props;
        return (
            <Modal
              title={title}
              visible={visible}
              onCancel={handleCancel}
              width={720}
              destroyOnClose={true}
              footer={[
                      <Button key="returnBtn" type="primary" onClick={handleCancel}>返回</Button>,
                      <Button key="moveBtn" type="primary" onClick={handleUpdate}>合并</Button>
                  ]}
            >
                <Form>
                    <FormItem
                      label="合并到"
                    >
                        <Tree
                            autoExpandParent={true}
                            onSelect={onSelectTreeNode}
                            defaultExpandedKeys={defaultExpandedKeys}
                          >
                              {this.renderTreeNodes(treeData)}
                         </Tree>
                    </FormItem>
                </Form>
            </Modal>
        )
    }
}

export default DepartmentMoveModal;



// WEBPACK FOOTER //
// ./src/components/DepartmentStructure/DepartmentMoveModal.js